import { FONT_LINEHEIGHT_DEFAULT, FONT_SIZE_100, SPACE_100 } from '@alltrails/denali/tokens';
import PopupOffset from '../../../types/PopupOffset';
import { poiPinHeightXs, poiPinIconWidthXs, poiPinImageWidthXs, poiPinVerticalOffset } from '../../../utils/svgDefinitions/svgMarkerComponents';

export function getPOIPopupOffset(hasProfileImage?: boolean): PopupOffset {
  const pinWidth = hasProfileImage ? poiPinImageWidthXs : poiPinIconWidthXs;
  return {
    bottom: [0, poiPinVerticalOffset - poiPinHeightXs - SPACE_100],
    'bottom-left': [pinWidth / -2, poiPinVerticalOffset - poiPinHeightXs - SPACE_100],
    'bottom-right': [pinWidth / 2, poiPinVerticalOffset - poiPinHeightXs - SPACE_100],
    // text height is dynamic - for simplicity, assume 1 line of text
    top: [0, poiPinVerticalOffset + FONT_SIZE_100 * FONT_LINEHEIGHT_DEFAULT],
    'top-left': [pinWidth / -2, poiPinVerticalOffset + FONT_SIZE_100 * FONT_LINEHEIGHT_DEFAULT],
    'top-right': [pinWidth / 2, poiPinVerticalOffset + FONT_SIZE_100 * FONT_LINEHEIGHT_DEFAULT],
    left: [pinWidth / 2 + SPACE_100, (poiPinVerticalOffset - poiPinHeightXs) / 2],
    right: [pinWidth / -2 - SPACE_100, (poiPinVerticalOffset - poiPinHeightXs) / 2]
  };
}
